var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#16181D;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.8,39.4H15.5c-2.2,0-4-1.8-4-4V15.2c0-2.2,1.8-4,4-4h20.3c2.2,0,4,1.8,4,4v20.3 C39.8,37.7,38,39.4,35.8,39.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.7,
    y1: 17,
    x2: 35.6,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.7,
    y1: 22.8,
    x2: 35.6,
    y2: 22.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.7,
    y1: 27.8,
    x2: 35.6,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.7,
    y1: 33.6,
    x2: 35.6,
    y2: 33.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon);
export default __webpack_public_path__ + "static/media/active_Icon.c0f73d8045cbf6ec1a07e1a06b5b9594.svg";
export { ForwardRef as ReactComponent };